import { AdvisorRuntimeIDBGroup } from '../_core/index.js';
import { Validator_GeneratedProps, Validator_RuntimeFinding } from './db-def.js';
export const DBDef_InvalidRuntimeFinding = {
    modifiablePropsValidator: Validator_RuntimeFinding,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'invalid-runtime-findings',
    entityName: 'invalid-runtime-finding',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'invalid-runtime-findings'
    },
    backend: {
        name: 'invalid-runtime-findings'
    }
};
//# sourceMappingURL=invalid-findings-db-def.js.map